import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import List from '@material-ui/core/List';

import ACDialog from '../../atoms/ACDialog';
import ACButton from '../../atoms/ACButton';
import SetChallenge from './SetChallenge';
import Challenge from './Challenge';
import { getUIElementsWithMedias, getUIElementType, getUIElement } from '../../common/global';

import styles from './Challenges.module.scss';

export default class Challenges extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      challenge: {},
      updateData: {},
      isACDialogOpen: false,
      errors: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { media = {} } = this.props;

    if (!isEmpty(media) && media !== prevProps.media) {
      this.updateMedia(media);
    }
  }

  updateMedia(media) {
    const { challenge = {} } = cloneDeep(this.state);
    const { name, url } = media;
    let uiElement = {};
    let uiEleMedia = {};
    switch (name) {
      case 'introduction':
        uiElement = getUIElement(challenge.uiElements, getUIElementType().introduction);
        break;
      case 'callOut':
        uiElement = getUIElement(challenge.uiElements, getUIElementType().callOut);
        break;
      case 'main':
        uiElement = getUIElement(challenge.uiElements, getUIElementType().main);
        break;
      case 'hint':
        uiElement = getUIElement(challenge.uiElements, getUIElementType().hint);
        break;
      case 'solution':
        uiElement = getUIElement(challenge.uiElements, getUIElementType().solution);
        break;
      default:
        break;
    }
    uiEleMedia = uiElement.media || {};
    uiEleMedia.url = url;
    uiElement.media = uiEleMedia;
    this.updateChallengeData(cloneDeep(uiElement));
  }

  updateChallengeData(uiElement) {
    const { challenge = {}, updateData } = cloneDeep(this.state);
    let { uiElements = [] } = challenge;
    const { type = '', subType = '' } = uiElement;
    uiElements = uiElements ? uiElements : [];
    const index = uiElements.findIndex((ele) => {
      if (!isEmpty(subType)) {
        return ele.type === type && ele.subType === subType;
      } else return ele.type === type && isEmpty(ele.subType);
    });
    if (index >= 0) uiElements[index] = uiElement;
    else uiElements.push(uiElement);

    challenge.uiElements = uiElements;
    updateData.uiElements = uiElements;
    this.setState({ challenge, updateData });
  }

  onOpenModal = () => {
    this.setState({ isModalOpen: true });
  };

  onCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  onClickACDialogOK = () => {
    this.setState({ isACDialogOpen: false, errors: [] });
  };

  onClickACDialogClose = () => {
    this.setState({ isACDialogOpen: false, errors: [] });
  };

  onSelectChallenge = (challenge) => {
    this.setState({ challenge, updateData: {} });
    this.onOpenModal();
  };

  onCopyChallenge = (challenge) => {
    const { onSaveChallengeFunc } = this.props;
    const { name = '' } = challenge;
    challenge.name = `Copy of ${name}`;
    delete challenge.id;
    onSaveChallengeFunc(challenge);
  };

  onChangeChallenge = (name, value) => {
    const { challenge = {}, updateData } = cloneDeep(this.state);
    challenge[name] = value;
    updateData[name] = value;
    this.setState({ challenge, updateData });
  };

  onAddChallenge = () => {
    const challenge = { id: -1, status: 'active' };
    this.setState({ challenge, updateData: { status: 'active' } });
    this.onOpenModal();
  };

  onSaveChallenge = (closeWindow = true) => {
    if (this.checkForErrors()) {
      this.setState({ isACDialogOpen: true });
      return Promise.reject();
    }
    const { challenge, updateData } = cloneDeep(this.state);

    if (!isEmpty(challenge) && challenge.id !== -1) updateData.id = challenge.id;
    const { uiElements = [] } = updateData;
    if (!isEmpty(uiElements)) updateData.uiElements = getUIElementsWithMedias(uiElements);
    this.props.onSaveChallengeFunc(updateData);
    if (closeWindow) {
      this.onCloseModal();
    }
    return Promise.resolve(true);
  };

  checkForErrors() {
    const { errors = [], challenge } = cloneDeep(this.state);
    const { name, type } = challenge;
    if (isEmpty(name)) {
      errors.push('Please enter a name for the challenge');
    }
    if (isEmpty(type)) {
      errors.push('Please select a type');
    }
    this.setState({ errors });
    if (!isEmpty(errors)) return true;

    return false;
  }

  render() {
    const { challenges = [], uploadMediaFunc } = this.props;
    const { isModalOpen = false, challenge = {}, isACDialogOpen = false, errors } = cloneDeep(
      this.state
    );

    return (
      <div className={styles.root}>
        <div className={styles.title}>
          Available Challenges
          <ACButton
            text={'Add'}
            icon={<AddCircleOutlineIcon />}
            iconLast={true}
            onClickFunc={this.onAddChallenge}
          />
        </div>

        <List className={styles.challengeList}>
          {challenges.map((challenge) => {
            return (
              <Challenge
                key={`challenge-${challenge.id || '0'}`}
                challenge={challenge}
                onClickChallengeFunc={this.onSelectChallenge}
                onCopyChallengeFunc={this.onCopyChallenge}
              />
            );
          })}
        </List>
        <SetChallenge
          challenge={challenge}
          spark={this.props.spark}
          challenges={challenges}
          isModalOpen={isModalOpen}
          onCloseFunc={this.onCloseModal}
          onChangeChallengeFunc={this.onChangeChallenge}
          onSaveChallengeFunc={this.onSaveChallenge}
          uploadMediaFunc={uploadMediaFunc}
        />
        <ACDialog
          isOpen={isACDialogOpen}
          heading="Error"
          body={errors}
          okButtonLabel="OK"
          onClickOkFunc={this.onClickACDialogOK}
          onClickACDialogClose={this.onClickACDialogClose}
        />
      </div>
    );
  }
}
